// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d0a1a58","239":"0995ef02","243":"ab5a475d","586":"faf35a2c","654":"b9c3a423","667":"89592fa0","673":"7c7e84af","841":"28cfd271"}[chunkId] + ".chunk.js";
};